import "./typo.css";
import "./audit.css";
import "./newfooter.css";

import heroAudit from "./asset-source/audit/hero.png";
import chart from "./asset-source/audit/chart.svg";
import graph from "./asset-source/audit/graph.svg";
import question from "./asset-source/audit/question.svg";
import s6 from "./asset-source/crm-erm.png";
import s6h from "./asset-source/crm-erm-h.png";
import s3 from "./asset-source/corporate.png";
import s3h from "./asset-source/corporate-h.png";
import s1 from "./asset-source/service.png";
import s1h from "./asset-source/service-h.png";
import plane31 from "./asset-source/plane31.png";

import { Footer } from "./components/footer/footer";

import { useState } from "react";

import { Header } from "./components/header-new/header";

import ContactUsModal from "./components/modal/contact-us";
import { useNavigate } from "react-router-dom";
import AuditFaq from "./components/audit-faq/audit-faq";

function UXPage() {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [currentField, setCurrentField] = useState("");
  const [nameUser, setNameUser] = useState("");
  const [contacts, setContact] = useState("");
  const [textfield, setTextfield] = useState("");
  const [time, setTime] = useState("1 мес");
  const [budget, setBudget] = useState(3);

  const [consultingAccrodeon, setConsultingAccrodeon] = useState(0);
  const [projectsAccrodeon, setProjectsAccrodeon] = useState(0);
  const [designAccrodeon, setDesignAccrodeon] = useState(0);
  const [brandingAccrodeon, setBrandingAccrodeon] = useState(0);
  const [supportAccrodeon, setSupportAccrodeon] = useState(0);

  const navigate = useNavigate();

  function handleConsultingAccrodeon(num) {
    if (consultingAccrodeon === num) {
      setConsultingAccrodeon(0);
    } else {
      setConsultingAccrodeon(num);
    }
  }

  function handleProjectsAccrodeon(num) {
    if (projectsAccrodeon === num) {
      setProjectsAccrodeon(0);
    } else {
      setProjectsAccrodeon(num);
    }
  }

  function handleDesignAccrodeon(num) {
    if (designAccrodeon === num) {
      setDesignAccrodeon(0);
    } else {
      setDesignAccrodeon(num);
    }
  }

  function handleBrandingAccrodeon(num) {
    if (brandingAccrodeon === num) {
      setBrandingAccrodeon(0);
    } else {
      setBrandingAccrodeon(num);
    }
  }

  function handleSupportAccrodeon(num) {
    if (supportAccrodeon === num) {
      setSupportAccrodeon(0);
    } else {
      setSupportAccrodeon(num);
    }
  }

  document.title =
    "Wjet – Юзабилити, дизайн и разработка цифровых продуктов для бизнеса";
  document.getElementsByTagName("META")[2].content =
    "Консультирование, аудит пользовательского опыта, UI/UX аудит, проектирование и дизайн интерфейсов, создание дизайн-систем для цифровых продуктов";

  document.getElementsByTagName("META")[3].content =
    "UX-исследования, Юзабилити-аудит, UX аудит, Дизайн интерфейсов, UX/UI проектирование, UI/UX дизайн, UI/UX для цифровых продуктов, Дизайн интерфейсов для приложений, Интерактивный прототип, Веб-дизайн, Адаптивный веб-дизайн, Создание MVP, Дизайн-система продукта";

  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 14000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // useEffect(() => {
  // 	if (modal || isMenuActive) {
  // 		document.body.style.overflow = "hidden";
  // 	} else {
  // 		document.body.style.overflow = "auto";
  // 	}
  // }, [modal, isMenuActive]);

  return (
    <div
      className="App uiux"
      onClick={() => {
        setCurrentField("");
      }}
    >
      <Header onLight />

      <section
        className="audit"
        id="top"
      >
        <div className="container">
          <div className="content">
            <h1 className="h1">UX/UI аудит цифрового продукта</h1>

            <div className="subtitle">
              Поможем найти пробелы в&nbsp;UX/UI вашего продукта. Покажем,
              что&nbsp;и&nbsp;как&nbsp;можно улучшить для&nbsp;роста KPI.
            </div>

            <button
              type="button"
              onClick={() => {
                navigate(`?modal`);
              }}
              className="action__button"
            >
              Получить консультацию
            </button>
          </div>

          <img
            src={heroAudit}
            alt=""
            className="heroAudit"
          />
        </div>
      </section>

      <section className="section auditNeeded">
        <div className="container">
          <div className="topAlignedTitle">
            <h2 className="h2">Когда UX/UI аудит необходим вашему продукту</h2>
            <img
              src={chart}
              alt=""
              className="hide--mobile"
            />
          </div>

          <div className="auditNeeded__grid">
            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">Низкая конверсия</h4>
              <div>
                Пользователи не&nbsp;оставляют заявки, не&nbsp;совершают
                покупки, не&nbsp;регистрируются
              </div>
            </div>

            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">Пользователи уходят</h4>
              <div>
                Закрывают сайт или&nbsp;приложение сразу, не&nbsp;переходя
                дальше и&nbsp;не&nbsp;взаимодействуя с&nbsp;контентом
              </div>
            </div>

            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">Запутанная навигация</h4>
              <div>
                Пользователи теряются в&nbsp;интерфейсе, не&nbsp;находят важные
                разделы и&nbsp;нужные кнопки,
                из-за&nbsp;чего&nbsp;не&nbsp;выполняют целевые действия
              </div>
            </div>

            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">
                Высокий процент отказов
              </h4>
              <div>
                Пользователи заходят, но&nbsp;ничего не&nbsp;читают,
                не&nbsp;взаимодействуют и&nbsp;уходят через&nbsp;несколько
                секунд
              </div>
            </div>

            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">Низкая вовлеченность</h4>
              <div>
                Пользователи проводят мало времени в&nbsp;продукте,
                не&nbsp;взаимодействуют с&nbsp;контентом
                и&nbsp;не&nbsp;возвращаются повторно.
              </div>
            </div>

            <div className="auditNeeded__item">
              <h4 className="auditNeeded__itemTitle">
                95% других проблем с&nbsp;UX/UI
              </h4>
              <div>
                Есть&nbsp;десятки других, менее очевидных ошибок, о&nbsp;которых
                вы&nbsp;даже&nbsp;не&nbsp;подозреваете&nbsp;— мы&nbsp;их найдём
                и&nbsp;покажем, как&nbsp;исправить
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section auditWalk">
        <div class="dotz">
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine delay2"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item unshine"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine delay2"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay1"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine4"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay2"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay2"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item"></div>
            <div class="dotz__item unshine delay2"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
            <div class="dotz__item unshine delay3"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine delay2"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item unshine"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine delay2"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay1"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine4"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item "></div>
            <div class="dotz__item unshine delay2"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine delay2"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item shine delay1"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="dotz__item shine delay3"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item shine4"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item"></div>
            <div class="dotz__item unshine"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item dotz__item--empty"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item"></div>
            <div class="dotz__item "></div>
            <div class="dotz__item "></div>
            <div class="dotz__item shine"></div>
            <div class="dotz__item"></div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item"></div>
              <div class="dotz__item dotz__item--empty"></div>
              <div class="dotz__item dotz__item--empty"></div>
              <div class="dotz__item dotz__item--empty"></div>
              <div class="dotz__item dotz__item--empty"></div>
              <div class="dotz__item shine delay3"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>

          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay3"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay3"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item unshine4 delay1"></div>

              <div class="dotz__item"></div>
            </div>
          </div>

          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item unshine4 delay1"></div>

              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item unshine4 delay1"></div>

              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine4 delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item unshine4 delay1"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine delay2"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item shine4"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay1"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item unshine delay2"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay3"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item unshine delay1"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item unshine delay3"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine delay3"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item shine delay2"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item shine4"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item shine delay1"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
          <div class="dotz__row">
            <div class="hide--mobile">
              <div class="dotz__item "></div>
              <div class="dotz__item shine delay2"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
              <div class="dotz__item "></div>
              <div class="dotz__item"></div>
              <div class="dotz__item"></div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="section__headingblock">
            <h2 class="h2">Как мы проводим UX/UI аудит</h2>
            <div class="section__description">
              Мы анализируем ваш продукт комплексно: от конкурентов до реального
              пользовательского опыта. Каждый этап — это шаг к улучшению
              интерфейса и росту показателей
            </div>
          </div>

          <div className="auditWalk__grid">
            <div className="auditWalk__row">
              <div className="auditWalk__line" />
              <div className="auditWalk__rowGrid">
                <div className="auditWalk__item">
                  <div className="auditWalk__itemLine" />
                  <div className="auditNeeded__itemTitle">
                    1. Погружение в продукт
                  </div>
                  <ul className="ul">
                    <li className="li">Интервью с заказчиком</li>
                    <li className="li">Анализ ЦА и ключевых метрик</li>
                    <li className="li">Исследование конкурентов</li>
                  </ul>
                  <div>Результат: Выявляем точки роста и проблемы UX/UI</div>
                </div>

                <div className="auditWalk__item">
                  <div className="auditWalk__itemLine" />
                  <div className="auditNeeded__itemTitle">2. Оценка UX/UI</div>

                  <ul className="ul">
                    <li className="li">Экспертная проверка интерфейса</li>
                    <li className="li">Анализ пользовательских сценариев</li>
                    <li className="li">Поиск проблем в навигации</li>
                  </ul>
                  <div>Результат: Выявление слабых мест и UX-барьеров</div>
                </div>
              </div>
            </div>

            <div className="auditWalk__row">
              <div className="auditWalk__line" />
              <div className="auditWalk__rowGrid auditWalk__rowGrid--backwards">
                <div className="auditWalk__item">
                  <div className="auditWalk__itemLine" />
                  <div className="auditNeeded__itemTitle">
                    3. Оценка пользовательского опыта
                  </div>
                  <ul className="ul">
                    <li className="li">Анализ пользовательского поведения</li>
                    <li className="li">
                      Юзабилити-тестирование на реальных пользователях
                    </li>
                    <li className="li">Проверка технических ограничений</li>
                  </ul>
                  <div>Результат: Подтверждение проблем и гипотез</div>
                </div>

                <div className="auditWalk__item">
                  <div className="auditWalk__itemLine" />
                  <div className="auditNeeded__itemTitle">
                    4. Подготовка отчёта и рекомендаций
                  </div>

                  <ul className="ul">
                    <li className="li">
                      Документ с приоритетными рекомендациями
                    </li>
                    <li className="li">Чек-лист исправлений</li>
                    <li className="li">Финальная консультация</li>
                  </ul>
                  <div>
                    Результат: Четкий план для улучшения вашего продукта
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={() => {
              navigate(`?modal`);
            }}
            className="action__button"
          >
            Обсудить аудит вашего продукта
          </button>
        </div>
      </section>

      <section className="section audiResults">
        <div className="container">
          <div className="topAlignedTitle">
            <div className="section__headingblock">
              <h2 className="h2">Какие результаты вы получите</h2>
              <div class="section__description">
                Мы знаем, почему ваш продукт не достигает желанных KPI, <br />
                и подскажем, как это исправить
              </div>
            </div>
            <img
              src={graph}
              alt=""
              className="hide--mobile"
            />
          </div>

          <div className="auditResulsGrid">
            <div className="products__card">
              <div className="products__hover">
                <div className="dotz">
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item inshune delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                </div>
              </div>
              <div className="products__icon">
                <img
                  src={s6}
                  alt=""
                  className="products__icon--main"
                />
                <img
                  src={s6h}
                  alt=""
                  className="products__icon--sub"
                />
              </div>
              <div>
                <div className="products__cardtitle">
                  Больше заявок и продаж
                </div>
                <div className="products__description">
                  Узнаете, какие UX-проблемы мешают пользователям завершать
                  целевые действия и поймёте, что с этим делать
                </div>
              </div>
            </div>

            <div className="products__card corp">
              <div className="products__hover">
                <div className="dotz">
                  <div className="dotz__row">
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item inshune delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                </div>
              </div>
              <div className="products__icon">
                <img
                  src={s3}
                  alt=""
                  className="products__icon--main"
                />
                <img
                  src={s3h}
                  alt=""
                  className="products__icon--sub"
                />
              </div>
              <div>
                <div className="products__cardtitle">
                  Меньше потерь пользователей
                </div>
                <div className="products__description">
                  Узнаете, на каких этапах пользователи теряют интерес
                  и что мешает им двигаться дальше
                </div>
              </div>
            </div>

            <div className="products__card">
              <div className="products__hover">
                <div className="dotz">
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item inshune delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                </div>
              </div>
              <div className="products__icon">
                <img
                  src={s1}
                  alt=""
                  className="products__icon--main"
                />
                <img
                  src={s1h}
                  alt=""
                  className="products__icon--sub"
                />
              </div>
              <div>
                <div className="products__cardtitle">Интуитивный интерфейс</div>
                <div className="products__description">
                  Узнаете, какие элементы сбивают пользователей с толку
                  и как сделать взаимодействие логичным и удобным
                </div>
              </div>
            </div>

            <div className="products__card">
              <div className="products__hover">
                <div className="dotz">
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item shine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item inshune delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item shine delay2"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine delay3"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine4"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item shine"></div>
                    <div className="dotz__item unshine delay1"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                  </div>
                  <div className="dotz__row">
                    <div className="dotz__item "></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item unshine"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item"></div>
                    <div className="dotz__item dotz__item--empty"></div>
                    <div className="dotz__item"></div>
                  </div>
                </div>
              </div>
              <div className="products__icon">
                <img
                  src={s6}
                  alt=""
                  className="products__icon--main"
                />
                <img
                  src={s6h}
                  alt=""
                  className="products__icon--sub"
                />
              </div>
              <div>
                <div className="products__cardtitle">
                  Осознанные решения для роста
                </div>
                <div className="products__description">
                  На основе данных и анализа получите конкретные рекомендации
                  и чёткий план действий для улучшения продукта
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="crypto__ready">
        <div className="container">
          <div className="ready__content">
            <h2 className="h2">
              Заставьте все KPI вашего продукта взлететь с UX/UI аудитом
              от наших экспертов
            </h2>

            <button
              onClick={() => {
                navigate(`?modal`);
              }}
              className="btn"
            >
              Заказать аудит
            </button>
          </div>
          <div className="ready__plane">
            <img
              src={plane31}
              alt=""
            />
          </div>
        </div>
      </section>

      <section className="section uiux__faq">
        <div className="container">
          <div className="topAlignedTitle">
            <h2 className="h2">Часто задаваемые вопросы</h2>
            <img
              src={question}
              alt=""
              className="hide--mobile"
            />
          </div>

          <AuditFaq />

          <div className="uiux__answer">
            <div>Не нашли ответ на свой вопрос?</div>
            <button
              type="button"
              onClick={() => {
                navigate(`?modal`);
              }}
              className="action__button"
            >
              Напишите нам
            </button>
          </div>
        </div>
      </section>

      <section className="footersection">
        <div
          className="container"
          id="contacts"
        >
          <Footer backgroundColor="transparent" />
        </div>
      </section>
      <ContactUsModal />
    </div>
  );
}

export default UXPage;
